<template>
    <div class="events-main-header row">
       <div class="events-search-wrapper col-12 col-md-5 pb-3">
        <p class="event-filter-header">Search by event name</p>
        <search-small
          :placeholder="'Search by event name or category'"
          :reset-value="resetFiltersFlag"
          @on-keyup="updateSearchTerm"
          @on-enter="updateSearchTerm"
          ref="eventsSearchBox"
        ></search-small>
       </div>
       <div class="events-date-picker-wrapper col-12 col-md-5 pb-3">
        <p class="event-filter-header">Date</p>
        <date-picker
          v-model="dateValue"
          :reset-value="resetFiltersFlag"
          data-vv-validate-on="input"
          :label="'Select time frame'"
          :set-min-date="true"
          :range="true"
          @input="updateDateFilterValue"
        />
       </div>
       <div class="edit-interest-wrapper col-12 col-md-2 pb-3 pt-md-4 justify-content-md-end">
        <edit-event-interests-button 
          class="pt-1" 
          :topics="topics"
          :showSubtitle="false">
        </edit-event-interests-button>
       </div>
    </div>
</template>
<script>
import DatePicker from "@/components/homebase/DatePicker";
import SearchSmall from "@/components/homebase/SearchSmall";
import EditEventInterestsButton from "@/components/homebase/buttons/EditEventInterestsButton";

export default {
    name: "event-feed-filters",
    props: [
      "topics", 
      "resetFilters"
    ],
    watch: { 
      resetFilters: function(resetFiltersFlag) {
          if(resetFiltersFlag) {
            this.resetFiltersFlag = true;
          }
      }
    },
    components: {
        DatePicker,
        SearchSmall,
        EditEventInterestsButton
    },
    data() {
        return {
            dateValue: null,
            resetFiltersFlag: false
        }
    },
    methods: {
      updateSearchTerm(payload) {
        this.resetSearchBoxValue = false;
        this.resetFiltersFlag = false;
        this.$emit('updateSearchTerm', payload)
      },
      updateDateFilterValue(val) {
        this.resetFiltersFlag = false;
        this.dateValue = val;
        this.$emit('updateDateFilterValue', this.dateValue);
      }
    }
}
</script>
<style scoped>
.events-main-header {
  display: flex;
}
.event-filter-header {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}
.events-search-wrapper {
  width: 45%;
  padding-bottom: 36px;
}
.events-search-wrapper > div { 
  max-width: 550px !important;
}
.events-date-picker-wrapper {
  width: 45%;
}
.edit-interest-wrapper {
  width: 10%;
  float: right;
  display: flex;
  align-items: center;
}
.edit-interest-wrapper > div {
  float: right;
}
</style>